import React from 'react';

const OrderDetail = () => {
  return (
    <>
    </>
  );
};

export default OrderDetail;
